<script>
	import listBase from '@_system/components/base/list.vue'
	import previewIndex from '../../preview/index.vue'
	import uploadBlue from '../../upload/blue.vue'
	import uploadRed from '../../upload/red.vue'
	import enterForm from '../../enter/index.vue'
	export default {
		extends: listBase,
		name: 'universalinvoiceIndex',
		props: {

		},
		render(h) {
			this.$slots.mainheader = [
				<el-switch style="padding-left:20px" v-model={this.showIsdrop} onChange={this.isdropChange} active-text="显示作废" inactive-text=""></el-switch>,
			]
			this.$slots.plug = [ 
				<preview-index  ref = "previewIndex" data={this.currentrow} />,
				<upload-blue ref = "uploadBlue"  data={this.currentrow} onSubmit={this.uploadBlueSubmit} />,
				<upload-red ref = "uploadRed"  data={this.currentrow} onSubmit={this.uploadRedSubmit} />,
				<enter-form ref = "enterForm" type={this.type}  data={this.currentrow} onSuccess={this.enterFormSuccess} />,
			]
			return listBase.render.call(this, h)
		},
		data() {
			return {
				moduleName: 'universalinvoice',
				windowName: '线下单开票',
				// windowType: 'modal',
				windowType: 'window',
				currentrow:{},
				showIsdrop:0,
				type:'unserlineorder'
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {
			this.foreingKey.type = this.type
		},
		computed: {

		},

		methods: {
			isdropChange(e){
				this.foreingKey.isdrop = e?1:0
				this.customreload()
			},
			drop(row){
				this.$confirm('是否确认作废，作废后无法恢复','提示').then(()=>{
					this.loading = true
					this.$api.universalinvoice.drop({
						id:row.id
					}).then(()=>{
						this.loading = false
						this.$message.success('提交成功')
						this.customreload()
					},()=>{
						this.loading = false
					})
				})
			},
			detail(row){
				this.currentrow = row
				this.$nextTick(()=>{
					this.$refs.previewIndex.modal_show()
				})
			},
			autoinvoice(){
				let data = this.$refs[this.moduleName+'_list'].getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}		
				this.currentrow = data			
				this.$nextTick(()=>{
					this.$refs.uploadBlue.modal_show()
				})
			},
			uploadBlueSubmit(e){
				let ids = e.data.map((item)=>{
					return item.id
				})
				this.$confirm('是否确认开票？','提示').then(()=>{
					this.loading = true
					this.$api.universalinvoice.createBlueInvoiceTask({
						ids:ids,
						type:'blue'
					}).then(()=>{
						this.loading = false
						this.$message.success('提交成功')
						this.customreload()
					},()=>{
						this.loading = false
					})
				})
			},
			autoredinvoice(){
				let data = this.$refs[this.moduleName+'_list'].getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}
				this.currentrow = data		
				this.$nextTick(()=>{
					this.$refs.uploadRed.modal_show()
				})
				
			},
			uploadRedSubmit(e){
				let ids = e.data.map((item)=>{
					return item.id
				})
				this.$confirm('是否确认冲红？','提示').then(()=>{
					this.loading = true
					this.$api.universalinvoice.createBlueInvoiceTask({
						ids:ids,
						type:'red'
					}).then(()=>{
						this.loading = false
						this.$message.success('提交成功')
						this.customreload()
					},()=>{
						this.loading = false
					})
				})
			},
			enterFormSuccess(){
				
			}
		},
		components: {
			previewIndex,
			uploadBlue,
			uploadRed,
			enterForm
		}
	}
</script>
